module.exports = __webpack_public_path__ + "img/house_tech_Normal_ua.dfeb7dc1.webp";